export default __webpack_public_path__ + "media/images/blue_arrow-63ef298af28bfbf8e0ef492eb76ad506.png";